import { Platform, Pressable, StyleSheet, Text, View } from 'react-native'
import { colors, fontFamily, fontWeight, radius } from '../tokens'
import { FulfilmentReminders } from './FulfilmentReminders'

type Props = {
  onCheckAnother: () => void
}

const BigCheck = () =>
  Platform.OS === 'web' ? (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width={34}
      height={34}
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ color: '#fff' }}
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ) : (
    <Text style={{ color: '#fff', fontSize: 28, fontWeight: '800' }}>✓</Text>
  )

// Replaces the stepper once the user confirms they've sent the email.
// The reminder timeline activates so they can see what we'll do next.
export const FulfilmentSent = ({ onCheckAnother }: Props) => (
  <View style={styles.card}>
    <View style={styles.sent}>
      <View style={styles.icon}>
        <BigCheck />
      </View>
      <Text style={styles.title}>That's the hard part done.</Text>
      <Text style={styles.body}>
        Your Band Review is on its way to the Valuation Office. We'll keep an eye on the clock and
        email you if it's time to nudge them — you don't need to track anything.
      </Text>
      <View style={styles.track}>
        <Text style={styles.trackHead}>Your reminder schedule</Text>
        <FulfilmentReminders active={3} />
      </View>
      <View style={styles.actions}>
        <Pressable accessibilityRole="button" onPress={onCheckAnother} style={styles.ghostButton}>
          <Text style={styles.ghostText}>Check another property</Text>
        </Pressable>
      </View>
    </View>
  </View>
)

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: radius.lg,
    paddingHorizontal: 30,
  },
  sent: { alignItems: 'center', paddingVertical: 46, paddingHorizontal: 30 },
  icon: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: colors.positive,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.serif,
    color: colors.ink,
    marginBottom: 10,
    letterSpacing: -0.5,
  },
  body: {
    fontSize: 15,
    color: colors.muted,
    textAlign: 'center',
    maxWidth: 420,
    lineHeight: 23,
  },
  track: { maxWidth: 440, marginTop: 30, width: '100%' },
  trackHead: {
    fontSize: 12,
    fontWeight: fontWeight.semibold,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: colors.muted,
    textAlign: 'center',
    marginBottom: 6,
  },
  actions: { width: '100%', maxWidth: 440, marginTop: 30 },
  ghostButton: {
    height: 50,
    borderWidth: 1.5,
    borderColor: colors.borderStrong,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.surface,
  },
  ghostText: { color: colors.ink, fontSize: 15, fontWeight: fontWeight.semibold },
})
